import { ISolServiceMock } from "./sol.types";

export const mockSolService = (): ISolServiceMock => ({
  validateSolClient: jest.fn(),
  validateSolSubclient: jest.fn(),
  validateSolServicepoint: jest.fn(),
});
